// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AnnouncementBar_wrapper__tyJln","bar":"AnnouncementBar_bar__GT5SU","icon":"AnnouncementBar_icon__79LLZ","text":"AnnouncementBar_text__Xq_dC"};